import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSectors = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.99976 12C1.99976 6.5 6.49976 2 11.9998 2C17.4998 2 21.9998 6.5 21.9998 12C21.9998 17.5 17.4998 22 11.9998 22C6.49976 22 1.99976 17.5 1.99976 12ZM19.9294 11.0002C19.4794 7.40022 16.6094 4.52022 12.9994 4.07021V10.0002C12.9994 10.5502 13.4494 11.0002 13.9994 11.0002H19.9294ZM3.99937 12.0002C3.99937 7.94022 7.06937 4.56021 10.9994 4.07021V19.9402C7.06937 19.4402 3.99937 16.0602 3.99937 12.0002ZM12.9994 14.0002V19.9302C16.6094 19.4802 19.4794 16.6102 19.9294 13.0002H13.9994C13.4494 13.0002 12.9994 13.4502 12.9994 14.0002Z",
		fill: "currentColor"
	})
});
export default SvgSectors;
